/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_SuggestionInputs */

const en_read_along_ai_suggestion = /** @type {(inputs: Read_Along_Ai_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic uses GPT-OSS for small documents and sections, and Qwen with reasoning off for medium documents. Either can take over if a request fails.`)
};

const es_read_along_ai_suggestion = /** @type {(inputs: Read_Along_Ai_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático usa GPT-OSS para documentos pequeños y secciones, y Qwen sin razonamiento para documentos medianos. Si una solicitud falla, se prueba el otro modelo.`)
};

/**
* | output |
* | --- |
* | "Automatic uses GPT-OSS for small documents and sections, and Qwen with reasoning off for medium documents. Either can take over if a request fails." |
*
* @param {Read_Along_Ai_SuggestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_suggestion = /** @type {((inputs?: Read_Along_Ai_SuggestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_SuggestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_suggestion(inputs)
	return en_read_along_ai_suggestion(inputs)
});